export default "__VITE_ASSET__uMo0P0l$__"